import {Section} from "../grouping/Section";
import {ListItemButton} from "../ListItemButton";
import {Button, Col, Form, FormControl, FormGroup, FormLabel, Row} from "react-bootstrap";
import {useCallback, useMemo, useState} from "react";
import {FILE_EMPTY, useFileMutations} from "../../api/fileapi";
import {useForm} from "../../utilities/formutilities";
import {ModalContentContainer} from "../grouping/ModalContentContainer";
import {ButtonLoading} from "../ButtonLoading";
import {SelectionList} from "../SelectionList";
import {ModalPopUp} from "../grouping/ModalPopUp";
import {MAGAZINE_EMPTY, useMagazineMutations} from "../../api/magazinesapi";
import {
    MAGAZINE_HEADING_EMPTY, useMagazineHeadingHeading,
    useMagazineHeadingHeadings, useMagazineHeadingsMutations,

} from "../../api/magazineheadingsapi";
import {ConfirmToast} from "../ConfirmToast";

export function MagazineOption(props) {
    const {magazineHeadings} = useMagazineHeadingHeadings();

    const [open, setOpen] = useState(false);
    const [fileEditing, setFileEditing] = useState(undefined);
    const {title} = props;
    return <Section title={title}>
        <Col xs={12} className={"text-end"}>
            <Button onClick={() => setOpen(true)}>Nieuw</Button>
        </Col>
        <SelectionList>
            {magazineHeadings ? magazineHeadings.sort((p1, p2) => new Date(p2.date.substring(0, 10)) - new Date(p1.date.substring(0, 10))).map(p =>
                <ListItem
                    key={p.id} onOpenChanged={setOpen}
                    partner={p}
                    onFileEditingChanged={setFileEditing}></ListItem>) : ""}
        </SelectionList>
        <ModalPopUp open={open} onOpenChanged={setOpen} title={"Nieuw tijdschrift"}
                    modalContent={<FileOptionModalContent fileEditing={fileEditing}
                                                          setFileEditing={setFileEditing}
                                                          onOpenChanged={setOpen}/>}/>
    </Section>
}


function ListItem(props) {
    const {partner, onOpenChanged, icon, onFileEditingChanged} = props;
    return <div className={"mt-1 border border-black rounded-2"}>
        <ListItemButton onClick={() => {
            onFileEditingChanged(partner);
            onOpenChanged(true);
        }}>
            <Col className={"text-start"}>
                {partner ? partner.title : "Geen Titel"}
            </Col>
            <Col xs={"auto"} className={"text-end"}>
                {icon}
            </Col>
        </ListItemButton>
    </div>
}

function FileOptionModalContent(props) {
    const {onOpenChanged, fileEditing, setFileEditing} = props;
    const [isLoading, setIsLoading] = useState(false);
    const {deleteMagazineHeading, editMagazineHeading, createMagazineHeading} = useMagazineHeadingsMutations()
    const initialObjectInintializer = useCallback(() => fileEditing ? {
        ...fileEditing,
        date: fileEditing.date?.substring(0, 10)
    } : {
        ...MAGAZINE_HEADING_EMPTY,
        date: new Date().toISOString().substring(0, 10)
    }, [])
    const {onChange, tempObject} = useForm(initialObjectInintializer);

    function handleCreateSubmit(event) {
        event.preventDefault();

        const result = createMagazineHeading({...tempObject, date: tempObject.date + 'T00:00:00'});
        if (result) onOpenChanged(false);
        setIsLoading(false)
        setFileEditing(undefined);
    }

    function handleEditSubmit(event) {
        event.preventDefault();
        const result = editMagazineHeading({...tempObject, date: tempObject.date + 'T00:00:00'});
        if (result) onOpenChanged(false);
        setIsLoading(false);
        setFileEditing(undefined);
    }

    return <ModalContentContainer onOpenChanged={onOpenChanged} onEditingChanged={setFileEditing}>
        <Section title={fileEditing ? "Wijzig collectie" : "Nieuwe magazine collectie"}>
            <FormLabel>{fileEditing ? "Wijzig collectie titel" : "Collectie titel"}</FormLabel>
            <FormControl value={tempObject.title}
                         onChange={e => onChange(e, "title")}></FormControl>
            <FormLabel>{fileEditing ? "Wijzig omschrijving" : "Omschrijving"}</FormLabel>
            <FormControl value={tempObject.description} onChange={e => onChange(e, "description")}/>
            <FormLabel>Datum</FormLabel>
            <FormControl type={"date"} value={tempObject.date} onChange={e => onChange(e, "date")}/>

            {fileEditing ?
                <AddNewMagazine magazineHeadingId={fileEditing?.id} isLoading={isLoading}
                                onIsLoadingChange={setIsLoading}/>
                : ""}

            {fileEditing ?

                <Col xs={6}>
                    <ConfirmToast title={"Delete"} className={"mt-3 btn-danger"}
                                  message={"Wil je deze collectie verwijderen?"}
                                  executeFunction={async () => {
                                      setIsLoading(true);
                                      const message = await deleteMagazineHeading(fileEditing);
                                      if (message) onOpenChanged(false);
                                      setFileEditing(undefined);
                                      setIsLoading(false);
                                  }}/>
                </Col> : ""}
            <Col xs={fileEditing ? 6 : 12} className={"text-end mt-3"}>
                <ButtonLoading isLoading={isLoading} title={"Opslaan"} onClick={event => {
                    setIsLoading(true);
                    fileEditing ? handleEditSubmit(event) : handleCreateSubmit(event)
                }}/>
            </Col>
        </Section>
    </ModalContentContainer>
}

function AddNewMagazine(props) {
    const {magazineHeadingId} = props;

    const {magazineHeading} = useMagazineHeadingHeading(magazineHeadingId);
    const [isLoading, setIsLoading] = useState(false);
    const {uploadFile} = useFileMutations();
    const {createMagazine, editRelation} = useMagazineMutations();
    const initialFileObjectInitializer = useCallback(() => FILE_EMPTY, []);
    const {onFileInputChange, tempFileObject} = useForm(initialFileObjectInitializer)
    const initialObjectInintializer = useCallback(() => {
        return {...MAGAZINE_EMPTY, date: new Date().toISOString().substring(0, 10)}
    }, [])
    const {onChange, tempObject} = useForm(initialObjectInintializer);

    async function handleCreateMagazine(event) {
        event.preventDefault();
        //first upload file
        const resultFile = await uploadFile(tempFileObject);
        if (resultFile) {
            //if file upload succes create magazine and give file to object
            const resultCreateMagazine = await createMagazine({
                ...tempObject,
                file: resultFile,
                date: tempObject.date + 'T00:00:00',

            });

            if (resultCreateMagazine) {
                const resultEdit = await editRelation({
                    ...resultCreateMagazine,
                    timeMagazineHeaderId: magazineHeading.id
                })
            }

        }
        setIsLoading(false);
    }

    return <Row className={"g-0"}>
        <hr className={"my-3"}/>
        <Col xs={12} className={"text-center"}>
            <h5>Voeg een nieuwe magazine toe aan deze collectie</h5>
        </Col>
        <FormLabel>Magazine titel</FormLabel>
        <FormControl value={tempObject.title} onChange={e => onChange(e, "title")}/>
        <FormLabel>Magazine omschrijving</FormLabel>
        <FormControl value={tempObject.description} onChange={e => onChange(e, "description")}/>
        <FormLabel>Datum van de magazine</FormLabel>
        <FormControl type={"date"} value={tempObject.date} onChange={e => onChange(e, "date")}/>
        <FormLabel>Selecteer magazine pdf bestand</FormLabel>
        <FormControl type={"file"} onChange={e => onFileInputChange(e, "file", false)}/>
        <Col xs={12} className={"text-end mt-2"}>
            <ButtonLoading isLoading={isLoading} title={"Voeg magazine toe"} onClick={async e => {
                setIsLoading(true);
                await handleCreateMagazine(e);
            }}/>
        </Col>
        <hr className={"my-3"}/>
        <Section title={"Collectie magazines"}>
            {magazineHeading?.timeMagazines?.sort((p1, p2) => new Date(p2.date.substring(0, 10)) - new Date(p1.date.substring(0, 10))).map(m =>
                <MagazineListItem key={m.id} isLoading={isLoading}
                                  onLoadingChange={setIsLoading} magazine={m}/>)}
        </Section>


    </Row>
}

function MagazineListItem(props) {

    const {magazine, isLoading, onLoadingChange} = props;

    const {deleteMagazine} = useMagazineMutations();
    return <Row className={"g-0 shadow rounded-2 mt-2 px-3 py-1"}>
        <Col xs={"auto"} className={"me-3"}>
            <p className={"fw-bolder"}>Titel: <span className={"fw-normal"}>{magazine?.title}</span></p>
        </Col>
        <Col xs={"auto"} className={"me-3"}>
            <p className={"fw-bolder"}>Omschrijving: <span className={"fw-normal"}>{magazine?.description}</span></p>
        </Col>
        <Col xs={"auto"}>
            <p className={"fw-bolder"}>Datum: <span className={"fw-normal"}>{magazine?.date.substring(0, 10)}</span></p>
        </Col>
        <Col className={"text-end"}>
            <ConfirmToast title={"Verwijder"} className={"btn-warning "}
                message={"Wil je deze magazine verwijderen?"}
                          executeFunction={async () => {

                onLoadingChange(true);
                await deleteMagazine(magazine);
                onLoadingChange(false);
            }}/>
        </Col>
    </Row>
}